<template>
  <div class="fullGift radius-8px" v-if="fullgift && fullgift.length">
    <ul class="flex jc-c ai-fe f14 pagination ml10 mr10 br8">
      <li
        :class="{
          'selected f14 fw-b': activeIndex == index,
          btlr8: activeIndex != index && index == 0,
          btrr8: activeIndex != index && index == fullgift.length - 1
        }"
        :style="
          activeIndex == index
            ? { background: item.color, color: '#fff' }
            : { background: item.color + '4D', color: item.color }
        "
        @click="activeHandle(index)"
        class="ta-c f13"
        v-for="(item, index) in fullgift"
        :key="index"
      >
        {{ item.ad_title }}
      </li>
    </ul>
    <swiper :options="fullGiftSwiper" id="swiperFullGift" ref="fullGiftSwiperRef">
      <swiper-slide class="h-100" v-for="(item, index) in fullgift" :key="index">
        <img :src="item.img_path" alt="" class="h-100 w-100 br8 of-c radius-8px" />
        <div
          :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=19'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
        ></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { isWeixin, checkAgent } from '../../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import adExposeMixin from '../js/adExposeMixin'

Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'fullGift',
  mixins: [adExposeMixin],
  components: {},
  props: {
    fullgift: {
      type: Array,
      default: function () {
        return []
      }
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'FULLGIFT'
    },
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      activeIndex: 0,
      fullGiftSwiper: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        on: {
          slideChangeTransitionEnd: function () {
            that.activeIndex = this.activeIndex
            var el = that.$refs.fullGiftSwiperRef && that.$refs.fullGiftSwiperRef.$el
            that.notifyAdExposeCarouselHandle(el)
          },
          click: function () {
            var activeIndex = this.clickedIndex
            that.$emit('banner-click', that.fullgift[activeIndex], activeIndex, that.flow_area_prefix + '-' + (activeIndex + 1))
          }
        }
      }
    }
  },
  computed: {
    fullGiftSwiperRef() {
      return this.$refs.fullGiftSwiperRef.swiper
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperClickHandler()
      this.bindFullGiftExposeHandle()
    })
  },
  watch: {
    fullgift: function () {
      this.scheduleAdExposeBindHandle(this.bindFullGiftExposeHandle)
    }
  },
  methods: {
    // swiper点击兼容鸿蒙系统
    swiperClickHandler() {
      if (!this.fullgift.length || !this.$refs.fullGiftSwiperRef) return
      const swiperEl = this.$refs.fullGiftSwiperRef.$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          const slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            this.$emit('banner-click', this.fullgift[id], id, this.flow_area_prefix + '-' + (id + 1))
          }
        })
      }
    },
    activeHandle(index) {
      this.activeIndex = index
      this.fullGiftSwiperRef.slideTo(index, 1000, false)
      var el = this.$refs.fullGiftSwiperRef && this.$refs.fullGiftSwiperRef.$el
      this.notifyAdExposeCarouselHandle(el)
    },
    bindFullGiftExposeHandle: function () {
      var that = this
      var comp = this.$refs.fullGiftSwiperRef
      if (!comp || !comp.$el || !this.fullgift.length) return
      this.bindAdExposeCarouselHandle(comp.$el, {
        get_index: function () {
          return that.activeIndex || 0
        },
        get_item: function (idx) {
          return that.fullgift[idx] || {}
        },
        make_key: function (idx) {
          return that.flow_area_prefix + '-' + (idx + 1)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#swiperFullGift {
  height: 1.68rem;
}
.br8 {
  border-radius: 0.08rem;
}
.pagination {
  li {
    width: 0.84rem;
    height: 0.24rem;
    line-height: 0.24rem;
    &.btlr8 {
      border-top-left-radius: 0.08rem;
    }
    &.btrr8 {
      border-top-right-radius: 0.08rem;
    }
    &.selected {
      width: 0.83rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.08rem 0.08rem 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actFullGift.vue